export default {
footer: {
    ageRestriction: "हमारा प्लेटफ़ॉर्म केवल 18 वर्ष और उससे अधिक आयु के उपयोगकर्ताओं के लिए है। जुआ खेलना व्यसनकारी हो सकता है। कृपया जिम्मेदारी से और केवल मनोरंजन के लिए खेलें। अधिक जानकारी के लिए, हमारे जिम्मेदार गेमिंग पेज पर जाएं।",
    followUs: "हमें फॉलो करें",
    company: "कंपनी",
    legal: "कानूनी",
    support: "सहायता",
    gameProviders: "गेम प्रदाता",
    copyright: "Copyright © 2019-2026 LOGO. सभी अधिकार सुरक्षित।",
	documents: "दस्तावेज़",
  }
}
